import { render, staticRenderFns } from "./NewDay.vue?vue&type=template&id=e47c74b8&"
import script from "./NewDay.vue?vue&type=script&lang=js&"
export * from "./NewDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports